<template>
  <div
    class="
      tw-size-full tw-flex tw-flex-col tw-justify-center tw-items-center tw-px-4
    "
    data-testid="checks-empty-panel"
  >
    <div
      class="
        tw-rounded-lg
        tw-bg-sf-snow-lighter
        tw-w-[900px]
        tw-h-[400px]
        tw-flex
        tw-flex-col
        tw-gap-4
        tw-justify-center
        tw-items-center
      "
    >
      <img
        class="tw-max-w-[300px]"
        :src="$imagesRequire('empty_states/communication.svg')"
      />
      <div class="tw-font-medium tw-text-lg tw-text-sf-gray">
        {{ I18n.t('assistant_check.page.checks_container.empty.title') }}
      </div>
      <div class="tw-font-normal tw-text-sm tw-text-sf-gray">
        {{ I18n.t('assistant_check.page.checks_container.empty.text') }}
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import useI18n from '@app/shared/vue/composables/use-I18n'

const I18n = useI18n()
</script>
